// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeSiteAccountApi = class EdgeSiteAccountApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param PatientsSearchPatientsRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientsSearchAllProgramPatients(PatientsSearchPatientsRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/v2/Patients/SearchAllProgramPatients';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PatientsSearchPatientsRequestModel' is not null or undefined
        if (PatientsSearchPatientsRequestModel === null || PatientsSearchPatientsRequestModel === undefined) {
            throw new Error('Required parameter PatientsSearchPatientsRequestModel was null or undefined when calling patientsSearchAllProgramPatients.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PatientsSearchPatientsRequestModel, "PatientsSearchPatientsRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2PatientsSearchAllProgramPatientsSearchAllProgramPatientsResponse");
        }
        return response;
    }
    /**
     *
     * @param AccountsByCaseSearchRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientsSearchPatientAccountsByCaseSearch(AccountsByCaseSearchRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/v2/Patients/SearchPatientAccountsByCaseSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'AccountsByCaseSearchRequestModel' is not null or undefined
        if (AccountsByCaseSearchRequestModel === null || AccountsByCaseSearchRequestModel === undefined) {
            throw new Error('Required parameter AccountsByCaseSearchRequestModel was null or undefined when calling patientsSearchPatientAccountsByCaseSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(AccountsByCaseSearchRequestModel, "AccountsByCaseSearchRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2PatientsSearchPatientAccountsByCaseSearchSearchPatientAccountsByCaseSearchResponse");
        }
        return response;
    }
    /**
     *
     * @param PrescriberSearchRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientsSearchPatientAccountsByPrescriber(PrescriberSearchRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/v2/Patients/SearchPatientAccountsByPrescriber';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PrescriberSearchRequestModel' is not null or undefined
        if (PrescriberSearchRequestModel === null || PrescriberSearchRequestModel === undefined) {
            throw new Error('Required parameter PrescriberSearchRequestModel was null or undefined when calling patientsSearchPatientAccountsByPrescriber.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PrescriberSearchRequestModel, "PrescriberSearchRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2PatientsSearchPatientAccountsByPrescriberSearchPatientAccountsByPrescriberResponse");
        }
        return response;
    }
    /**
     *
     * @param PatientsSearchPatientsRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientsSearchPatients(PatientsSearchPatientsRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/v2/Patients/SearchPatients';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PatientsSearchPatientsRequestModel' is not null or undefined
        if (PatientsSearchPatientsRequestModel === null || PatientsSearchPatientsRequestModel === undefined) {
            throw new Error('Required parameter PatientsSearchPatientsRequestModel was null or undefined when calling patientsSearchPatients.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PatientsSearchPatientsRequestModel, "PatientsSearchPatientsRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2PatientsSearchPatientsSearchPatientsResponse");
        }
        return response;
    }
    /**
     *
     * @param CancelWorkflowRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async siteAccountCancelWorkflow(CancelWorkflowRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/CancelWorkflow';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'CancelWorkflowRequestModel' is not null or undefined
        if (CancelWorkflowRequestModel === null || CancelWorkflowRequestModel === undefined) {
            throw new Error('Required parameter CancelWorkflowRequestModel was null or undefined when calling siteAccountCancelWorkflow.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(CancelWorkflowRequestModel, "CancelWorkflowRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountCancelWorkflowDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param SiteAccountRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async siteAccountCreateSiteAccount(SiteAccountRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/v2/SiteAccount/createSiteAccount';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'SiteAccountRequestModel' is not null or undefined
        if (SiteAccountRequestModel === null || SiteAccountRequestModel === undefined) {
            throw new Error('Required parameter SiteAccountRequestModel was null or undefined when calling siteAccountCreateSiteAccount.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(SiteAccountRequestModel, "SiteAccountRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2SiteAccountCreateSiteAccountCreateSiteAccountResponse");
        }
        return response;
    }
    /**
     *
     * @param GetAccountRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async siteAccountGetAccount(GetAccountRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/GetAccount';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GetAccountRequestModel' is not null or undefined
        if (GetAccountRequestModel === null || GetAccountRequestModel === undefined) {
            throw new Error('Required parameter GetAccountRequestModel was null or undefined when calling siteAccountGetAccount.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GetAccountRequestModel, "GetAccountRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountGetAccountDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param GetCaseRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async siteAccountGetCase(GetCaseRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/GetCase';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GetCaseRequestModel' is not null or undefined
        if (GetCaseRequestModel === null || GetCaseRequestModel === undefined) {
            throw new Error('Required parameter GetCaseRequestModel was null or undefined when calling siteAccountGetCase.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GetCaseRequestModel, "GetCaseRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountGetCaseDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param GetCasesRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async siteAccountGetCases(GetCasesRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/GetCases';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GetCasesRequestModel' is not null or undefined
        if (GetCasesRequestModel === null || GetCasesRequestModel === undefined) {
            throw new Error('Required parameter GetCasesRequestModel was null or undefined when calling siteAccountGetCases.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GetCasesRequestModel, "GetCasesRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountGetCasesDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param body default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async siteAccountGetParty(body, x_program_id) {
        const _url_ = '/edge/siteAccount/GetParty';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling siteAccountGetParty.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountGetPartyDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param body default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async siteAccountGetSiteAccount(body, x_program_id) {
        const _url_ = '/edge/siteAccount/GetSiteAccount';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling siteAccountGetSiteAccount.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountGetSiteAccountDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param GetWorkflowsRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async siteAccountGetWorkflows(GetWorkflowsRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/GetWorkflows';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GetWorkflowsRequestModel' is not null or undefined
        if (GetWorkflowsRequestModel === null || GetWorkflowsRequestModel === undefined) {
            throw new Error('Required parameter GetWorkflowsRequestModel was null or undefined when calling siteAccountGetWorkflows.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GetWorkflowsRequestModel, "GetWorkflowsRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountGetWorkflowsDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param SearchAccountsRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async siteAccountSearchAccounts(SearchAccountsRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/SearchAccounts';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'SearchAccountsRequestModel' is not null or undefined
        if (SearchAccountsRequestModel === null || SearchAccountsRequestModel === undefined) {
            throw new Error('Required parameter SearchAccountsRequestModel was null or undefined when calling siteAccountSearchAccounts.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(SearchAccountsRequestModel, "SearchAccountsRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSearchAccountsDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param SearchCasesRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async siteAccountSearchCases(SearchCasesRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/SearchCases';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'SearchCasesRequestModel' is not null or undefined
        if (SearchCasesRequestModel === null || SearchCasesRequestModel === undefined) {
            throw new Error('Required parameter SearchCasesRequestModel was null or undefined when calling siteAccountSearchCases.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(SearchCasesRequestModel, "SearchCasesRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSearchCasesDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param SearchWorkflowsRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async siteAccountSearchWorkflows(SearchWorkflowsRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/SearchWorkflows';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'SearchWorkflowsRequestModel' is not null or undefined
        if (SearchWorkflowsRequestModel === null || SearchWorkflowsRequestModel === undefined) {
            throw new Error('Required parameter SearchWorkflowsRequestModel was null or undefined when calling siteAccountSearchWorkflows.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(SearchWorkflowsRequestModel, "SearchWorkflowsRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSearchWorkflowsDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param SiteAccountsRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async siteAccountSiteAccountsByPortalId(SiteAccountsRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/v2/SiteAccount/siteAccountsByPortalId';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'SiteAccountsRequestModel' is not null or undefined
        if (SiteAccountsRequestModel === null || SiteAccountsRequestModel === undefined) {
            throw new Error('Required parameter SiteAccountsRequestModel was null or undefined when calling siteAccountSiteAccountsByPortalId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(SiteAccountsRequestModel, "SiteAccountsRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2SiteAccountSiteAccountsByPortalIdSiteAccountsByPortalIdResponse");
        }
        return response;
    }
    /**
     *
     * @param SiteAccountsAlternateRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async siteAccountSiteAccountsByPortalIdAlternate(SiteAccountsAlternateRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/v2/SiteAccount/siteAccountsByPortalIdAlternate';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'SiteAccountsAlternateRequestModel' is not null or undefined
        if (SiteAccountsAlternateRequestModel === null || SiteAccountsAlternateRequestModel === undefined) {
            throw new Error('Required parameter SiteAccountsAlternateRequestModel was null or undefined when calling siteAccountSiteAccountsByPortalIdAlternate.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(SiteAccountsAlternateRequestModel, "SiteAccountsAlternateRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountV2SiteAccountSiteAccountsByPortalIdAlternateSiteAccountsByPortalIdAlternateResponse");
        }
        return response;
    }
    /**
     *
     * @param ISiteRegistrationRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async siteAccountSiteRegistration(ISiteRegistrationRequestModel, x_program_id) {
        const _url_ = '/edge/siteAccount/SiteRegistration';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ISiteRegistrationRequestModel' is not null or undefined
        if (ISiteRegistrationRequestModel === null || ISiteRegistrationRequestModel === undefined) {
            throw new Error('Required parameter ISiteRegistrationRequestModel was null or undefined when calling siteAccountSiteRegistration.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ISiteRegistrationRequestModel, "ISiteRegistrationRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteAccountSiteRegistrationDefaultResponse");
        }
        return response;
    }
};
EdgeSiteAccountApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeSiteAccountApi);
export { EdgeSiteAccountApi };
//# sourceMappingURL=edgeSiteAccountApi.js.map